// extracted by mini-css-extract-plugin
export var rightPanelOpen = "_8l-0";